import { createContext } from "react";
import React from "react";
import type { RevealingIds } from "./RevealingIds";

/**
 * The setter is published separately from the flag, and as the raw `useState`
 * dispatch, because it must be referentially stable: `useReportTextReveal`
 * lists it as an effect dependency, and a setter re-created each render would
 * re-run the effect — cleanup included — on every state change it caused,
 * which is an infinite loop rather than a re-render.
 */
export const SetRevealingIdsContext = createContext<React.Dispatch<
  React.SetStateAction<RevealingIds>
> | null>(null);
